export default RAILS_ASSET_URL("/poppins-v15-latin-600.woff2")
